<div hidden>
  <label for="input-name_{{catalog.id}}_{{catalog.turn}}--readonly">
    {{catalog.name}}
  </label>
  <div *ngIf="catalog.filled">
    <input name="input-name_{{catalog.id}}_{{catalog.turn}}--readonly" [(ngModel)]="catalog.withEvidence" validation
      [readonly]="true" [required]="catalog.filled && !readonly"
      requiredMessage="Debes indicar si el campo '{{catalog.name}}' es con o sin evidencia de patología" />
    <textarea name="input-name_{{catalog.id}}_{{catalog.turn}}--readonly" [(ngModel)]="catalog.details" [rows]="2"
      validation [readonly]="true" [required]="catalog.filled && !readonly">
    </textarea>
  </div>
</div>